import React, { useEffect } from "react";
import "./BookingTracking.scss";
import { TrackingPageHeader } from "./TrackingPageHeader";
import { BookingTrackingContainer } from "./BookingTrackingContainer";
import { Separator } from "./Separator";
import { Dispatch } from "../../Dispatch";
import { BookingFlowTriggerSource } from "../../UILogicControl/UILogicControlEntities";
import { ErrorMessage } from "./Notifications/ErrorMessage";

/**
 * Booking tracking component. This is opened when the user clicks the link in the SMS they receive after making a booking through a voice channel (e.g. IVR, Contact center). This page allows users to track the status of their booking and see the details of their booking. This page also allows the user to convert the booking in to a Fixed Price booking and pay with a digital payment method (e.g.: 16 digit card, ApplePay, GPay etc).
 */
export const BookingTracking: React.FC = () => {

    useEffect(() => {
        Dispatch.UILogicControl.BookingFlowTrigger(BookingFlowTriggerSource.TrackingSms);

        // Google Pay SDK takes a while to load and initialise. If it is initialised after the user clicks on the payment dropdown, it appears with a delay and it is possible that the user misses it. Hence, initialise the SDK loading on page load, so the user has a better chance of seeing the Google Pay option without delay when they click on the payment dropdown.
        Dispatch.GooglePay.ReadyToLoad();        
    }, []);

    return (
        <div>
            <TrackingPageHeader />
            <Separator />
            <BookingTrackingContainer />
            <ErrorMessage />
        </div>
    )
}